module.exports = __webpack_public_path__ + "static/placeholder-square-2382b9ebd9764a0189a341fda95ea381.jpg";